import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { Provider as d } from "./components/Provider.js";
import { Content as l } from "./components/Content.js";
import { Trigger as s } from "./components/Trigger.js";
const g = ({
  content: o,
  trigger: i,
  disabled: t,
  position: e = "top",
  triggerAsChild: m = !0,
  openedTooltipClassName: p
}) => /* @__PURE__ */ n(d, { position: e, disabled: t, children: [
  /* @__PURE__ */ r(
    s,
    {
      asChild: m,
      openedTooltipClassName: p,
      children: i
    }
  ),
  /* @__PURE__ */ r(l, { children: o })
] });
export {
  g as Tooltip
};
//# sourceMappingURL=index.js.map
